import React, { useState } from 'react'
import SupplierDeliveryInfo from '@/components/FulfilmentBox/SupplierDeliveryInfo/SupplierDeliveryInfo'
import { InfoCircleIcon } from './InfoCircleIcon'
import SdfDrawer from '../../SdfDrawer/SdfDrawer'
import * as Styled from './SdfLink.styles'

const SdfLink = ({ isV2 }) => {
  const [show, setShow] = useState(false)

  const toggleDrawer = () => setShow(prevShow => !prevShow)

  const button = isV2 ? (
    <SupplierDeliveryInfo onClick={toggleDrawer} id='sdf-drawer-link' />
  ) : (
    <Styled.SdfContainer
      id='sdf-drawer-link'
      onClick={toggleDrawer}
      onKeyPress={toggleDrawer}
      role='link'
      tabIndex='0'
      aria-expanded={show}
    >
      <Styled.InfoIcon>
        <InfoCircleIcon />
      </Styled.InfoIcon>
      <Styled.DrawerLink>Delivered by our supplier</Styled.DrawerLink>
    </Styled.SdfContainer>
  )

  return (
    <>
      {button}
      <SdfDrawer isDrawerOpen={show} toggleSdfDrawer={toggleDrawer} />
    </>
  )
}

export default SdfLink
